import { connect } from 'react-redux';
import styled from 'styled-components';

import MalwareIcon from 'components/Icon/Malware';

import { getActiveFile } from './data/reducer';

const Container = styled.div`
  background: transparent;
  display: flex;
  height: 100%;
  justify-content: center;
`;

const Label = styled.div`
  margin-bottom: 0;
  font-weight: 600;
  text-align: center;
`;

const Wrapper = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

const LabelText = styled.span`
  color: #444;
  text-transform: uppercase;
  letter-spacing: 1px;
  font-weight: 500;
  margin-bottom: 0.5em;
  display: block;
`;

const FileName = styled.h2`
  font-weight: 700;
  font-size: 1.6rem;
`;

const StyledMalwareIcon = styled(MalwareIcon)`
  height: auto;
  max-height: 100%;
  max-width: 100%;
  object-fit: contain;
  width: fit-content;
  vertical-align: middle;
  padding: 15%;
`;

const connector = connect((state) => ({
  activeFile: getActiveFile(state),
}));

const MalwareDetectedScreen = ({ activeFile }) => (
  <Container>
    <Wrapper>
      <Label>
        <StyledMalwareIcon />
        <LabelText>Malware Detected</LabelText>
        <FileName>{activeFile?.filename ?? 'unknown'}</FileName>
      </Label>
    </Wrapper>
  </Container>
);

export default connector(MalwareDetectedScreen);
